/**
 * PR-A: PENDING_PAYMENT 재결제 동선을 위한 sessionStorage 키 공용 유틸.
 *
 * SpaceReservationPage 가 토스 SDK 호출 직전에 저장하는 6개 키를
 * 단일 위치에서 관리한다. 흩어진 인라인 removeItem 호출을 이 함수 하나로 통일.
 *
 * 호출 시점:
 *  - SpaceReservationPage: 새 booking 시작 직전 (stale 컨텍스트 제거)
 *  - PaymentFailPage: "예약 포기" 명시 클릭 후 성공적으로 cancel 됐을 때만
 *  - clearAuthSession: 로그아웃 / 세션 만료 시 (다른 계정 booking stale 방지)
 */
export const PENDING_CHECKOUT_KEYS = [
  'bander_pending_checkout_id',
  'bander_pending_checkout_revision',
  'bander_pending_booking_id',
  'bander_pending_room_slug',
  'bander_pending_room_id',
] as const;

export type PendingCheckoutKey = (typeof PENDING_CHECKOUT_KEYS)[number];

export function clearPendingCheckoutContext(): void {
  if (typeof window === 'undefined') {
    return;
  }
  for (const key of PENDING_CHECKOUT_KEYS) {
    window.sessionStorage.removeItem(key);
  }
}

export function getPendingCheckoutContext(): {
  checkoutId: string | null;
  checkoutRevision: string | null;
  bookingId: string | null;
  roomSlug: string | null;
  roomId: string | null;
} {
  if (typeof window === 'undefined') {
    return {
      checkoutId: null,
      checkoutRevision: null,
      bookingId: null,
      roomSlug: null,
      roomId: null,
    };
  }
  return {
    checkoutId: window.sessionStorage.getItem('bander_pending_checkout_id'),
    checkoutRevision: window.sessionStorage.getItem('bander_pending_checkout_revision'),
    bookingId: window.sessionStorage.getItem('bander_pending_booking_id'),
    roomSlug: window.sessionStorage.getItem('bander_pending_room_slug'),
    roomId: window.sessionStorage.getItem('bander_pending_room_id'),
  };
}
